/**
 * การ์ดแนะนำผู้เล่นใหม่ (รอบ 18 · ความพร้อมปล่อยเดโม)
 *
 * เมืองไม่มีมอนแล้ว (ทุ่งดอกเช้าอยู่นอกประตูตะวันออก) คนเข้าเกมครั้งแรกจึงไม่รู้ว่าต้องไปไหน
 * ขึ้นครั้งเดียวตอนเข้าเกมครั้งแรก (`settings.guideSeen`) เปิดซ้ำได้จากแผงคำแนะนำ
 *
 * pure function — ข้อความสร้างจากปุ่มที่ผู้เล่นตั้งจริง (ปุ่มเปลี่ยนได้ ห้ามเขียนตัวอักษรตายตัว)
 */
export interface GuideKeys {
  attack: string;
  skill1: string;
  potion: string;
  char: string;
  skills: string;
  quest: string;
  map: string;
}

export function guideLines(k: GuideKeys, touch: boolean): string[] {
  if (touch) {
    return [
      "แตะ ผู้เฒ่าอิกนิส ข้างตะเกียงกลางเมือง เพื่อรับเควสแรก \"เปลวไฟดวงแรก\"",
      "เดินออกประตูตะวันออก (วงแสงสีฟ้าบนมินิแมพ) ไปทุ่งดอกเช้า — ในเมืองไม่มีมอน",
      "แตะมอนเพื่อตี · ปุ่มใหญ่ขวาล่างคือสกิล · ปุ่มยาอยู่แถวล่าง",
      "เลเวลขึ้นแล้วเปิดเมนู ☰ → ตัวละคร/สกิล เพื่อลงแต้ม (ไอคอนมีป้าย ! เมื่อมีแต้มรอ)",
      "ตายแล้วกลับเมืองได้เสมอ — บันทึกจุดเกิดและรับพรตะเกียงฟรีที่ผู้เฒ่าอิกนิส",
    ];
  }
  return [
    "คลิก ผู้เฒ่าอิกนิส ข้างตะเกียงกลางเมือง เพื่อรับเควสแรก \"เปลวไฟดวงแรก\"",
    `เดินออกประตูตะวันออก (วงแสงสีฟ้าบนมินิแมพ · ${k.map} เปิดแผนที่) ไปทุ่งดอกเช้า — ในเมืองไม่มีมอน`,
    `คลิกมอนเพื่อตี (${k.attack} สั่งตี/หยุด) · ${k.skill1} ใช้สกิลแรก · ${k.potion} ดื่มยาฟื้น HP`,
    `เลเวลขึ้นแล้วลงแต้ม: ${k.char} ตัวละคร · ${k.skills} สกิล · ${k.quest} เควส (ไอคอนมีป้าย ! เมื่อมีแต้มรอ)`,
    "ตายแล้วกลับเมืองได้เสมอ — บันทึกจุดเกิดและรับพรตะเกียงฟรีที่ผู้เฒ่าอิกนิส",
  ];
}
